<template>
  <div id="app">
    <md-app>
      <md-app-toolbar>
        <md-button class="md-icon-button md-xlarge-hide" @click="toggleMenu">
          <md-icon>menu</md-icon>
        </md-button>

        <div class="md-title" style="flex: 1">PleaseSign</div>

        <md-menu md-direction="bottom-end" v-bind:md-offset-y="12" v-if="logged">
          <md-button class="md-icon-button" md-menu-trigger>
            <md-icon>more_vert</md-icon>
          </md-button>

          <md-menu-content>
            <md-menu-item @click="logout">
              <md-icon>logout</md-icon>
              <span>Logout</span>
            </md-menu-item>
          </md-menu-content>
        </md-menu>
      </md-app-toolbar>
      <md-app-drawer md-permanent="full" v-if="logged" :md-active.sync="menuVisible">
        <md-toolbar class="md-transparent" md-elevation="0">
          <md-button class="md-icon-button md-dense md-xlarge-hide"
          @click="toggleMenu">
          <md-icon>keyboard_arrow_left</md-icon>
        </md-button>
          <div class="md-toolbar-section-end">
          </div>
        </md-toolbar>

        <md-list :md-expand-single="expandSingle">
          <md-list-item md-expand>
            <md-icon>business</md-icon>
            <span class="md-list-item-text">Business</span>

            <md-list slot="md-expand">
              <md-list-item class="md-inset">
                <router-link to="/businesses" class="md-list-item-text">
                  List businesses
                </router-link>
              </md-list-item>
              <md-list-item class="md-inset">
                <router-link
                  to="/businesses/create"
                  class="md-list-item-text"
                  v-t="'buttons.main.createBusiness'" />
              </md-list-item>
            </md-list>
          </md-list-item>

          <md-list-item md-expand>
            <md-icon>article</md-icon>
            <span class="md-list-item-text">Documents</span>

            <md-list slot="md-expand">
              <md-list-item class="md-inset">
                <router-link to="/documents" class="md-list-item-text">
                  Find a document
                </router-link>
              </md-list-item>
            </md-list>
          </md-list-item>

          <md-list-item md-expand>
            <md-icon>card_membership</md-icon>
            <span class="md-list-item-text">Promotions</span>

            <md-list slot="md-expand">
              <md-list-item class="md-inset">
                <router-link to="/promotions" class="md-list-item-text">
                  List promotions
                </router-link>
              </md-list-item>
            </md-list>
          </md-list-item>

          <md-list-item md-expand>
            <md-icon>people</md-icon>
            <span class="md-list-item-text">Administrators</span>

            <md-list slot="md-expand">
              <md-list-item class="md-inset">
                <router-link to="/administrators" class="md-list-item-text">
                  List administrators
                </router-link>
              </md-list-item>

              <md-list-item class="md-inset">
                <router-link to="/administrators/new" class="md-list-item-text">
                  Add administrator
                </router-link>
              </md-list-item>
            </md-list>
          </md-list-item>

          <md-list-item md-expand>
            <md-icon>event</md-icon>
            <span class="md-list-item-text">Global events</span>

            <md-list slot="md-expand">
              <md-list-item class="md-inset">
                <router-link to="/events" class="md-list-item-text">
                  List events
                </router-link>
              </md-list-item>
            </md-list>
          </md-list-item>

          <md-list-item md-expand>
            <md-icon>money</md-icon>
            <span class="md-list-item-text">Billing</span>

            <md-list slot="md-expand">
              <md-list-item class="md-inset">
                <router-link to="/billing-products" class="md-list-item-text">
                  Products &amp; prices
                </router-link>
              </md-list-item>
              <md-list-item class="md-inset">
                <router-link to="/subscriptions/past-due" class="md-list-item-text">
                  Past due subscriptions
                </router-link>
              </md-list-item>
              <md-list-item class="md-inset">
                <router-link to="/invoices/list-open" class="md-list-item-text">
                  Open invoices
                </router-link>
              </md-list-item>
              <md-list-item class="md-inset">
                <router-link to="/businesses/unbilled" class="md-list-item-text">
                  Unbilled businesses
                </router-link>
              </md-list-item>
              <md-list-item class="md-inset">
                <router-link to="/billing-provider/import" class="md-list-item-text">
                  Import from provider
                </router-link>
              </md-list-item>
            </md-list>
          </md-list-item>

          <md-list-item md-expand>
            <md-icon>apps</md-icon>
            <span class="md-list-item-text">Applications</span>

            <md-list slot="md-expand">
              <md-list-item class="md-inset">
                <router-link to="/applications" class="md-list-item-text">
                  List applications
                </router-link>
              </md-list-item>
              <md-list-item class="md-inset">
                <router-link to="/applications/pending" class="md-list-item-text">
                  Pending approval
                </router-link>
              </md-list-item>
            </md-list>
          </md-list-item>

          <md-list-item md-expand>
            <md-icon>settings</md-icon>
            <span class="md-list-item-text">System Settings</span>

            <md-list slot="md-expand">
              <md-list-item class="md-inset">
                <router-link to="/system-setting" class="md-list-item-text">
                  Email Provider
                </router-link>
              </md-list-item>
            </md-list>
          </md-list-item>

        </md-list>
      </md-app-drawer>
      <md-app-content>
        <router-view/>
      </md-app-content>
    </md-app>

    <snackbar-store-message-handler />
  </div>
</template>

<script>
import AuthService from '@/services/auth/AuthService';
import SnackbarStoreMessageHandler from '@/components/snackbarStoreMessage.vue';

export default {
  name: 'App',
  data: () => ({
    authService: new AuthService(),
    menuVisible: false,
    menuItem: '',
    logged: false,
    expandSingle: false,
  }),
  components: {
    SnackbarStoreMessageHandler,
  },
  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    toggleMenuItem(item) {
      this.menuItem = item;
    },
    logout() {
      this.authService.logout().then(() => {
        this.$store.commit('logout');
        if (this.$router.currentRoute.path !== '/login') {
          this.$router.push('/login');
        }
      });
    },
    verifyLogin(user) {
      return ((user.active === true) && (user.admin === true));
    },
    logoutUser() {
      this.$store.commit('logout');
      this.$router.push('/login');
    },
  },
  watch: {
    '$store.state.logged': function synchroniseLogged() {
      this.logged = this.$store.state.logged;
    },
  },

  mounted() {
    this.$router.beforeResolve((_to, _from, next) => {
      this.menuVisible = false;
      next();
    });
    if (this.authService.logged()) {
      this.authService.verifyCurrentProfile().then((response) => {
        if (this.verifyLogin(response.data)) {
          this.$store.commit('login');
        } else {
          this.logoutUser();
        }
      }).catch((error) => {
        if (error.response.status >= 400) {
          this.authService.logout().then(() => {
            this.logoutUser();
          });
        }
      });
    } else if (this.$router.currentRoute.path !== '/login') {
      this.logoutUser();
    }
  },
};
</script>

<style lang="scss">
.md-content.md-app-content {
  min-height: 100vh;
}
</style>
